import React from 'react';
import { useSetBreadcrumbs } from 'works/legacy/lib/client-store';
import { AppContent, ErrorHandler, LoadingState } from '@common/components';
import { Typography } from 'antd';
import { ORGANIZATION_ADMIN_MENU } from 'works/legacy/pages/organization/admin-settings/organization-admin-vertical-nav-menu';
import { useQuery } from '@common/hooks';
import {
  OrganizationSettingQuery,
  OrganizationSettingResponse,
} from 'works/legacy/graphql/organization-setting';
import { InvoiceDisputesForm } from '@pay-bill/components';

const { Title } = Typography;

export function AdminOrganizationBillingPage() {
  const { loading, error, data } = useQuery<OrganizationSettingResponse>(
    OrganizationSettingQuery
  );

  useSetBreadcrumbs([
    {
      name: ORGANIZATION_ADMIN_MENU.HOME.LABEL,
      path: ORGANIZATION_ADMIN_MENU.HOME.ROUTE,
    },
    {
      name: ORGANIZATION_ADMIN_MENU.BILLING.LABEL,
      path: ORGANIZATION_ADMIN_MENU.BILLING.ROUTE,
    },
  ]);

  if (loading) {
    return <LoadingState />;
  }

  if (error) {
    return <ErrorHandler error={error} log="AdminOrganizationBillingPage" />;
  }

  return (
    <>
      <AppContent className="admin-organization-billing-page">
        <div className="admin-organization-billing-title">
          <Title level={3}>Billing</Title>
        </div>
        <InvoiceDisputesForm organizationSetting={data?.organizationSetting} />
      </AppContent>
      <style jsx>{`
        .admin-organization-invoice-disputes-section {
          margin-top: 24px;
        }
      `}</style>
    </>
  );
}
